import React from 'react';
import { getDeviationType } from '../../DeviationViews/_helpers';
import { DeviationTypes } from '../../types/deviation';
import ImageView from './Image';
import UnknownView from './Unknown';
import JournalView from './Journal';
import StatusView from './Status';
import LiteratureView from './Literature';
import TierView from './Tier';
import CommissionView from './Commission';
import EditorDeviationLink from '../MonoView/_partials/DeviationLink';
const InlineView = (props)=>{
    let View;
    switch(getDeviationType(props.deviation)){
        // these types all have guaranteed thumb image
        case DeviationTypes.IMAGE:
        case DeviationTypes.PDF:
        case DeviationTypes.FILM:
            View = ImageView;
            break;
        case DeviationTypes.LITERATURE:
            View = LiteratureView;
            break;
        case DeviationTypes.STATUS:
            View = StatusView;
            break;
        case DeviationTypes.JOURNAL:
            View = JournalView;
            break;
        case DeviationTypes.TIER:
            View = TierView;
            break;
        case DeviationTypes.COMMISSION:
            View = CommissionView;
            break;
        default:
            View = UnknownView;
    }
    if (props.inEditor) {
        return /*#__PURE__*/ React.createElement(View, props);
    }
    return /*#__PURE__*/ React.createElement(EditorDeviationLink, {
        link: props.link,
        deviation: props.deviation
    }, /*#__PURE__*/ React.createElement(View, props));
};
InlineView.displayName = 'InlineView';
export default InlineView;

//# sourceMappingURL=InlineView.js.map